module.exports = __webpack_public_path__ + "img/agreement_completed.4b5c9c6f.png";